import { render, staticRenderFns } from "./AnNumber.vue?vue&type=template&id=495a96f1&scoped=true&"
import script from "./AnNumber.vue?vue&type=script&lang=js&"
export * from "./AnNumber.vue?vue&type=script&lang=js&"
import style0 from "./AnNumber.vue?vue&type=style&index=0&id=495a96f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a96f1",
  null
  
)

export default component.exports